import {
  FETCH_FEATURE_FLAGS,
  FETCH_FEATURE_FLAGS_SUCCESS,
  FETCH_FEATURE_FLAGS_FAILURE,
} from "./featureFlagsActionTypes";
import { FEATURES } from "app-constants";

const INITIAL_FEATURE_FLAGS = {};

export const featureFlagsReducer = (state = INITIAL_FEATURE_FLAGS, action) => {
  switch (action.type) {
    case FETCH_FEATURE_FLAGS: {
      return FEATURES.reduce(
        (accumulator, feature) => ({
          ...accumulator,
          [feature]: { fetching: true },
        }),
        {}
      );
    }

    case FETCH_FEATURE_FLAGS_SUCCESS: {
      const { features } = action.payload;
      return FEATURES.reduce((accumulator, feature) => {
        const match = features && features.find((f) => f.feature === feature);
        return {
          ...accumulator,
          [feature]: {
            fetching: false,
            enabled: match ? match.enabled : false,
          },
        };
      }, {});
    }

    case FETCH_FEATURE_FLAGS_FAILURE: {
      const { error } = action.payload;
      return FEATURES.reduce(
        (accumulator, feature) => ({
          ...accumulator,
          [feature]: { fetching: false, error },
        }),
        {}
      );
    }

    default:
      return state;
  }
};
